import { TrayStatus } from '../EditTrayModal/EditTrayModal.types'
import { useState } from 'react'
import { SelectChangeEvent } from '@mui/material'
import { TrayType } from '../AddTraySelectType/AddTraySelectType.types'

const useEditTrayStatusModalLogic = ({
  trayCategory,
}: {
  trayCategory?: TrayType['category']
}) => {
  const [selectedStatus, setSelectedStatus] = useState<TrayStatus>(undefined)

  const trayStatuses: TrayStatus[] = [
    'loaded',
    'readyToFill',
    'readyForPickup',
    'unAssigned',
    'checkedOut',
    'canceled',
    'assigned',
  ]

  const handleSelectedStatusChange = (e: SelectChangeEvent<TrayStatus>) => {
    setSelectedStatus(e.target.value as TrayStatus)
  }

  return {
    trayStatuses,
    selectedStatus,
    handleSelectedStatusChange,
  }
}

export default useEditTrayStatusModalLogic
